import type { Dictionary } from '../i18n';
import * as chrome from './pt/chrome';
import { auth } from './pt/auth';
import { dashboard } from './pt/dashboard';
import { people } from './pt/people';
import { onboarding } from './pt/onboarding';
import { teams } from './pt/teams';
import { articles } from './pt/articles';
import { settings } from './pt/settings';
import { admin } from './pt/admin';

/**
 * Portuguese (pt-PT) dictionary — the source of truth for all UI copy, merged
 * from the shared chrome and the per-area files. English (`en.ts`) mirrors this
 * exact shape (enforced by `AppDictionary`).
 */
export const pt = {
  common: chrome.common,
  roles: chrome.roles,
  modules: chrome.modules,
  moduleHints: chrome.moduleHints,
  shell: chrome.shell,
  topbar: chrome.topbar,
  nav: chrome.nav,
  notifications: chrome.notifications,
  attendance: chrome.attendance,
  impersonation: chrome.impersonation,
  cmd: chrome.cmd,
  status: chrome.status,
  tabbar: chrome.tabbar,
  shared: chrome.shared,
  bilingual: chrome.bilingual,
  auth,
  dashboard,
  people,
  onboarding,
  teams,
  articles,
  settings,
  admin,
} satisfies Dictionary;

export type AppDictionary = typeof pt;
